(() => {
  const productId = '12551282295102';
  if (window.czPdpShared?.config.productId !== productId) return;
  const groups = window.czPdpShared.config.groups;
  const groupById = new Map(groups.flatMap((group, index) => group.ids.map((id) => [id, index])));
  const conditionalTargets = {
    '4': { Black: '6', White: '35' },
    '20': { 'Runner for Ripple Fold': '34' },
    '39': { 'Rechargeable Battery': '42', 'Plug-in': '43' },
    '38': { 'Remote & Voice Control': '37' },
    '45': { 'Single-Channel Remote': '47', 'Multi-Channel Remote': '48' }
  };
  let root;
  let steps;
  let activeGroup = 0;
  let setupQueued = false;
  let refreshQueued = false;
  let summaryQueued = false;
  let intent;
  let conditionIntent;
  let conditionObserver;
  let lengthEditor;
  let positionToken = 0;
  let moneyObserver;

  function boxes(index) {
    return [...(root?.querySelectorAll('.ymq-options-box') || [])].filter((node) => node.closest('ymq-option') === root &&
      Number(node.dataset.czRylanGroup) === index);
  }

  function activeBox(box) {
    return window.czPdpShared.activeBox(box, '.cz-rylan-length-input');
  }

  function selectedValues(box) {
    return window.czPdpShared.values(box, '.cz-rylan-length-input');
  }

  function missingBox(index) {
    if (index === 4) {
      const mounting = root?.querySelector('.ymq-options-box[ymq-option-id="28"]');
      if (mounting && !mounting.querySelector('input[type="radio"]:checked')) return mounting;
    }
    return window.czPdpShared.missingRequired(boxes(index), '.cz-rylan-length-input');
  }

  function updateSummaries() {
    if (!root?.hasAttribute('data-cz-rylan-steps')) return;
    root.querySelectorAll('.ymq-options-box').forEach((box) => {
      if (selectedValues(box).length) box.querySelector(':scope > .cz-rylan-option-error')?.remove();
    });
    groups.forEach((group, index) => {
      const summary = root.querySelector(`.cz-rylan-option-step[data-cz-rylan-group="${index}"] .cz-rylan-option-step__summary`);
      if (!summary) return;
      const parts = [];
      const shown = boxes(index).filter((box) => !box.hidden && box.style.display !== 'none' && !box.classList.contains('ymq-option-condition-hide'));
      const length = shown.find((box) => box.getAttribute('ymq-option-id') === '44')?.querySelector('select')?.value;
      const fraction = shown.find((box) => box.getAttribute('ymq-option-id') === '30')?.querySelector('select')?.value;
      if (index === 1 && length) parts.push(`Length: ${length}${fraction && fraction !== '0' ? ` ${fraction}` : ''}″`);
      shown.forEach((box) => {
        const id = box.getAttribute('ymq-option-id');
        if (index === 1 && (id === '44' || id === '30')) return;
        const label = box.getAttribute('ymq-option-label');
        const values = selectedValues(box);
        if (label && values.length) parts.push(`${label}: ${values.join(', ')}`);
      });
      const empty = ['Choose color and cap style', 'Enter rod length', 'Choose runner and panel', 'Choose motor and control options', 'Choose mounting and optional details'];
      const text = parts.length ? parts.join(' · ') : empty[index];
      if (summary.textContent !== text) summary.textContent = text;
    });
    updatePurchaseSummary();
  }

  function updatePurchaseSummary() {
    const form = root?.closest('.product-form');
    const summary = form?.querySelector('.cz-your-selections');
    if (!summary) return;
    const chosen = (id) => {
      const box = root.querySelector(`.ymq-options-box[ymq-option-id="${id}"]`);
      return box && activeBox(box) ? selectedValues(box).join(', ') : '';
    };
    const length = chosen('44');
    const fraction = chosen('30');
    const rows = [
      ['Color', chosen('4')], ['Cap style', chosen('6') || chosen('35')],
      ['Rod length', length ? `${length}${fraction && fraction !== '0' ? ` ${fraction}` : ''}″` : 'Enter length'],
      ['Runner', chosen('20')], ['Panel configuration', chosen('36')],
      ['Motor side', chosen('40')], ['Power type', chosen('39')],
      ['Control method', chosen('38')], ['Remote control', chosen('45')],
      ['Mounting type', chosen('28') || 'Choose mounting'],
      ['Quantity', form.querySelector('input[name="quantity"]')?.value || '1'],
      ['Current price', form.querySelector('.price__current .money')?.textContent.trim() || form.querySelector('.product-page-subtotal-wrapper .money')?.textContent.trim() || '']
    ];
    summary.querySelectorAll('.cz-selection-row').forEach((row, index) => {
      const value = rows[index]?.[1] || '';
      row.querySelector('.cz-selection-value').textContent = value;
      row.hidden = !value;
    });
  }

  function setupPurchase() {
    const form = root?.closest('.product-form');
    const subtotal = form?.querySelector('.product-page-subtotal-wrapper');
    if (!form || !subtotal) return;
    if (!form.querySelector('.cz-your-selections')) {
      const summary = document.createElement('section');
      summary.className = 'cz-your-selections';
      summary.setAttribute('aria-label', 'Your selections');
      const heading = document.createElement('h3');
      heading.textContent = 'Your selections';
      summary.append(heading);
      ['Color', 'Cap style', 'Rod length', 'Runner', 'Panel configuration', 'Motor side', 'Power type', 'Control method', 'Remote control', 'Mounting type', 'Quantity', 'Current price'].forEach((label) => {
        const row = document.createElement('div');
        row.className = 'cz-selection-row';
        const title = document.createElement('strong');
        title.textContent = `${label}: `;
        const value = document.createElement('span');
        value.className = 'cz-selection-value';
        row.append(title, value);
        summary.append(row);
      });
      subtotal.before(summary);
    }
    moneyObserver?.disconnect();
    moneyObserver = new MutationObserver(updatePurchaseSummary);
    moneyObserver.observe(subtotal, {childList: true, characterData: true, subtree: true});
    const currentPrice = form.querySelector('.price__current');
    if (currentPrice) moneyObserver.observe(currentPrice, {childList: true, characterData: true, subtree: true});
    updatePurchaseSummary();
  }

  function requireMountingChoice() {
    const box = root.querySelector('.ymq-options-box[ymq-option-id="28"]');
    if (!box || box.dataset.czMountingReady) return;
    box.dataset.czMountingReady = 'true';
    const selected = box.querySelector('input[type="radio"]:checked');
    if (!selected) return;
    selected.checked = false;
    selected.removeAttribute('checked');
    selected.removeAttribute('ymq-option-checked');
    box.querySelector('.ymq-option-title-right-name')?.replaceChildren();
    box.dispatchEvent(new Event('change', {bubbles: true}));
  }

  function scheduleSummaries() {
    if (summaryQueued) return;
    summaryQueued = true;
    requestAnimationFrame(() => { summaryQueued = false; updateSummaries(); });
  }

  function positionTitle(title) {
    if (!title?.isConnected || !title.getBoundingClientRect().height) return;
    const token = ++positionToken;
    title.setAttribute('tabindex', '-1');
    title.focus({ preventScroll: true });
    const align = () => {
      if (token !== positionToken || !title.isConnected || !title.getBoundingClientRect().height) return;
      const sticky = root.closest('.product-form')?.querySelector('.app-title-price-wrapper');
      const stickyRect = sticky?.getBoundingClientRect();
      const clearance = sticky && getComputedStyle(sticky).position === 'sticky' && stickyRect ?
        Math.min(window.innerHeight - 80, Math.max(24, stickyRect.bottom + 16)) : 24;
      const destination = Math.max(0, window.scrollY + title.getBoundingClientRect().top - clearance);
      if (Math.abs(destination - window.scrollY) > 2) window.scrollTo({ top: destination, behavior: 'instant' });
    };
    align();
    requestAnimationFrame(() => { requestAnimationFrame(align); });
    setTimeout(align, 180);
    setTimeout(align, 400);
  }

  function setActive(index, focus = false) {
    if (!root) return;
    steps?.open(index, focus);
  }

  function applyActive(index) {
    activeGroup = index;
    root.querySelectorAll('.cz-rylan-option-step').forEach((button) => {
      button.setAttribute('aria-expanded', String(Number(button.dataset.czRylanGroup) === index));
    });
    for (let group = 0; group < groups.length; group++) {
      boxes(group).forEach((box) => box.toggleAttribute('data-cz-rylan-collapsed', group !== index));
    }
    const sizePanel = root.querySelector(':scope > .cz-rylan-size-panel');
    if (sizePanel) sizePanel.hidden = index !== 1;
    const confirm = root.querySelector('.cz-rylan-size-confirm');
    if (confirm) confirm.hidden = index !== 1;
    scheduleSummaries();
  }

  function fieldTitle(box) {
    return box?.querySelector('.ymq_lable') || box;
  }

  function showError(box) {
    const title = box.querySelector('.ymq-option-title');
    if (!title) return;
    let error = box.querySelector(':scope > .cz-rylan-option-error');
    if (!error) {
      error = document.createElement('p');
      error.className = 'cz-rylan-option-error';
      error.setAttribute('role', 'alert');
      title.after(error);
    }
    error.textContent = `Please choose ${box.getAttribute('ymq-option-label') || 'an option'} to continue.`;
  }

  function clearErrors(index) {
    boxes(index).forEach((box) => box.querySelector(':scope > .cz-rylan-option-error')?.remove());
  }

  function firstMissing() {
    for (let index = 0; index < groups.length; index++) {
      const box = missingBox(index);
      if (box) return { index, box };
    }
  }

  function gateAdd(event) {
    if (!root || !root.closest('product-form')?.contains(event.target)) return;
    const missing = firstMissing();
    if (!missing) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    intent = undefined;
    conditionIntent = undefined;
    setActive(missing.index);
    showError(missing.box);
    positionTitle(fieldTitle(missing.box));
  }

  function sizeValue(select, raw) {
    const value = raw.trim();
    return /^\d+$/.test(value) && [...select.options].some((option) => option.value === value && !option.disabled && !option.hidden) ? value : '';
  }

  function lengthMessage(input, select) {
    if (!input.value.trim()) return 'Enter the rod length in whole inches.';
    if (/^[+-]?\d*\.\d+$/.test(input.value.trim())) return 'Enter whole inches here. Choose the fractional inch separately.';
    const values = [...select.options].filter((option) => option.value && !option.disabled && !option.hidden).map((option) => option.value);
    return `Enter an available whole-inch rod length (${values[0]}–${values.at(-1)}).`;
  }

  function setLengthError(message = '') {
    if (!lengthEditor) return;
    lengthEditor.error.textContent = message;
    lengthEditor.error.hidden = !message;
    lengthEditor.input.setAttribute('aria-invalid', String(Boolean(message)));
  }

  function commitLength(showError = false) {
    if (!lengthEditor?.select.isConnected) return false;
    const { input, select } = lengthEditor;
    const value = sizeValue(select, input.value);
    setLengthError(!value && showError ? lengthMessage(input, select) : '');
    if (select.value !== value) {
      lengthEditor.pending = true;
      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }
    return Boolean(value);
  }

  function setupLengthInput() {
    const box = root?.querySelector('.ymq-options-box[ymq-option-id="44"]');
    const select = box?.querySelector('select');
    if (!select || select.disabled) return;
    if (lengthEditor?.select === select && lengthEditor.input.isConnected) return;
    box.querySelectorAll('.cz-rylan-length-input, .cz-rylan-length-error').forEach((node) => node.remove());
    box.classList.add('cz-rylan-length-main');
    root.querySelector('.ymq-options-box[ymq-option-id="30"]')?.classList.add('cz-rylan-length-fraction');
    const input = document.createElement('input');
    input.type = 'text';
    input.inputMode = 'numeric';
    input.autocomplete = 'off';
    input.className = 'cz-rylan-length-input';
    input.id = 'cz-rylan-length';
    input.setAttribute('aria-label', 'Rod length in whole inches');
    input.placeholder = 'Inches';
    input.value = select.value;
    const error = document.createElement('div');
    error.className = 'cz-rylan-length-error';
    error.id = 'cz-rylan-length-error';
    error.setAttribute('aria-live', 'polite');
    error.hidden = true;
    input.setAttribute('aria-describedby', error.id);
    select.after(input);
    select.closest('.ymq-option-select-wrapper')?.after(error);
    select.classList.add('cz-rylan-length-native');
    select.tabIndex = -1;
    select.setAttribute('aria-hidden', 'true');
    lengthEditor = { input, select, error, pending: false };
    input.addEventListener('input', () => { commitLength(); scheduleSummaries(); });
    input.addEventListener('blur', () => { if (commitLength(Boolean(input.value.trim()))) queueRefresh({ input, index: 1, fromTyping: true }); });
    input.addEventListener('change', () => commitLength(Boolean(input.value.trim())));
    select.addEventListener('change', () => {
      if (!lengthEditor.pending && document.activeElement !== input) {
        input.value = select.value;
        setLengthError();
      }
      lengthEditor.pending = false;
      scheduleSummaries();
    });
  }

  function setupHelp() {
    const anchor = root?.querySelector('.ymq-options-box[ymq-option-id="25"] a[href^="#"]');
    if (!anchor || anchor.dataset.czRylanHelp) return;
    const target = document.getElementById(anchor.hash.slice(1));
    const content = target?.querySelector('.rte');
    if (!content) return;
    document.querySelectorAll('.cz-rylan-length-help-dialog').forEach((previous) => previous.remove());
    const dialog = document.createElement('dialog');
    dialog.className = 'cz-rylan-help-dialog cz-rylan-length-help-dialog';
    dialog.setAttribute('aria-label', 'Rylan rod length guide');
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'cz-rylan-help-close';
    close.setAttribute('aria-label', 'Close rod length guide');
    close.textContent = '×';
    const title = document.createElement('strong');
    title.textContent = 'Rod length guide';
    const header = document.createElement('header');
    header.append(title, close);
    const body = document.createElement('div');
    body.className = 'cz-rylan-help-body';
    const copy = content.cloneNode(true);
    const renamed = new Map();
    copy.querySelectorAll('[id]').forEach((node, index) => {
      const oldId = node.id;
      const newId = `cz-rylan-help-${index}-${oldId}`;
      renamed.set(oldId, newId);
      node.id = newId;
    });
    copy.querySelectorAll('a[href^="#"]').forEach((link) => {
      const oldId = link.hash.slice(1);
      if (renamed.has(oldId)) link.hash = renamed.get(oldId);
    });
    body.append(copy);
    dialog.append(header, body);
    document.body.append(dialog);
    anchor.dataset.czRylanHelp = 'true';
    const zoom = root.querySelector('.cz-rylan-size-zoom');
    window.czPdpShared.bindDialog(dialog, close, [
      {button: anchor, beforeOpen: (event) => {
        event.preventDefault();
        dialog.querySelector('.cz-rylan-help-zoom-crop')?.remove();
      }},
      {button: zoom, beforeOpen: () => {
        if (dialog.querySelector('.cz-rylan-help-zoom-crop')) return;
        const preview = zoom?.querySelector('img');
        if (!preview) return;
        const crop = document.createElement('span');
        crop.className = 'cz-rylan-size-crop cz-rylan-size-crop--length cz-rylan-help-zoom-crop';
        const enlarged = preview.cloneNode(true);
        enlarged.className = 'cz-rylan-help-image';
        enlarged.alt = 'Rylan rod length measurement diagram';
        enlarged.loading = 'eager';
        crop.append(enlarged);
        dialog.querySelector('.cz-rylan-help-body')?.prepend(crop);
      }}
    ]);
  }

  function setupConnectorHelp(imageUrl) {
    const heading = root.querySelector(':scope > .cz-rylan-length-heading');
    if (!heading || heading.querySelector('.cz-rylan-connector-help') || !imageUrl) return;
    document.querySelectorAll('.cz-rylan-connector-dialog').forEach((previous) => previous.remove());
    const trigger = document.createElement('button');
    trigger.type = 'button';
    trigger.className = 'cz-rylan-connector-help';
    trigger.setAttribute('aria-label', 'Why does a Rylan rod over 78 inches need a metal connector?');
    trigger.setAttribute('aria-haspopup', 'dialog');
    trigger.textContent = '?';
    heading.append(trigger);

    const dialog = document.createElement('dialog');
    dialog.className = 'cz-rylan-help-dialog cz-rylan-connector-dialog';
    dialog.setAttribute('aria-label', 'Rylan metal connector');
    const header = document.createElement('header');
    const title = document.createElement('strong');
    title.textContent = 'Metal connector';
    const close = document.createElement('button');
    close.type = 'button';
    close.className = 'cz-rylan-help-close';
    close.setAttribute('aria-label', 'Close metal connector help');
    close.textContent = '×';
    header.append(title, close);
    const body = document.createElement('div');
    body.className = 'cz-rylan-help-body';
    const crop = document.createElement('span');
    crop.className = 'cz-rylan-size-crop cz-rylan-size-crop--connector';
    const image = document.createElement('img');
    image.src = imageUrl;
    image.alt = 'Rylan metal connector. Lengths greater than 78 inches will include a metal connector.';
    image.loading = 'lazy';
    crop.append(image);
    body.append(crop);
    dialog.append(header, body);
    document.body.append(dialog);
    window.czPdpShared.bindDialog(dialog, close, [{button: trigger}]);
  }

  function setupFieldHelp() {
    const guides = [
      {field: '39', title: 'Power type', sources: [['42', 'Rechargeable battery'], ['43', 'Plug-in']]},
      {field: '45', title: 'Remote control', sources: [['47', 'Single-channel remote'], ['48', 'Multi-channel remote']]}
    ];
    guides.forEach(({field, title, sources}) => {
      const box = root.querySelector(`.ymq-options-box[ymq-option-id="${field}"]`);
      const label = box?.querySelector('.ymq-option-title-wrapper');
      if (!label || label.querySelector('.cz-rylan-field-help')) return;
      const trigger = document.createElement('button');
      trigger.type = 'button';
      trigger.className = 'cz-rylan-field-help';
      trigger.setAttribute('aria-label', `Help with ${title}`);
      trigger.setAttribute('aria-haspopup', 'dialog');
      trigger.textContent = '?';
      label.append(trigger);
      const dialog = document.createElement('dialog');
      dialog.className = 'cz-rylan-help-dialog cz-rylan-field-dialog';
      dialog.setAttribute('aria-label', `${title} help`);
      const header = document.createElement('header');
      const heading = document.createElement('strong');
      heading.textContent = title;
      const close = document.createElement('button');
      close.type = 'button';
      close.className = 'cz-rylan-help-close';
      close.setAttribute('aria-label', `Close ${title} help`);
      close.textContent = '×';
      header.append(heading, close);
      const body = document.createElement('div');
      body.className = 'cz-rylan-help-body';
      sources.forEach(([id, sourceTitle]) => {
        const source = root.querySelector(`.ymq-options-box[ymq-option-id="${id}"]`);
        const original = source?.querySelector('.ymq-option-custome-text');
        if (!original) return;
        const subheading = document.createElement('h3');
        subheading.textContent = sourceTitle;
        body.append(subheading, original.cloneNode(true));
        source.dataset.czHelpSource = '';
      });
      dialog.append(header, body);
      document.body.append(dialog);
      window.czPdpShared.bindDialog(dialog, close, [{button: trigger}]);
    });
  }

  function setupWarrantyLink() {
    const box = root.querySelector('.ymq-options-box[ymq-option-id="185379tem11"]');
    if (!box || box.dataset.czWarrantyLink) return;
    const original = box.querySelector('a[href*="/pages/warranty"]');
    if (!original) return;
    const link = document.createElement('a');
    link.href = original.href;
    link.textContent = 'View warranty policy →';
    link.target = original.target;
    link.rel = original.rel || 'noopener';
    box.querySelector('.ymq-option-custome-text')?.replaceChildren(link);
    box.dataset.czWarrantyLink = 'true';
  }

  function setup() {
    const next = document.querySelector(`main ymq-option[ymq-option-product-id="${productId}"]`);
    if (!next) return;
    const nativeBoxes = [...next.querySelectorAll('.ymq-options-box')].filter((box) => box.closest('ymq-option') === next);
    if (nativeBoxes.length !== groupById.size || nativeBoxes.some((box) => !groupById.has(box.getAttribute('ymq-option-id')))) return;
    if (root !== next) {
      conditionObserver?.disconnect();
      root = next;
      steps = window.czPdpShared.controller(root, {
        count: groups.length,
        initial: activeGroup,
        apply: applyActive,
        beforeToggle: () => { intent = undefined; conditionIntent = undefined; },
        position: (index) => positionTitle(root.querySelector(`.cz-rylan-option-step[data-cz-rylan-group="${index}"]`)),
        onComplete: () => {
          const quantity = root.closest('.product-form')?.querySelector('input[name="quantity"]');
          if (quantity) positionTitle(quantity);
        }
      });
      conditionObserver = new MutationObserver(() => { scheduleSummaries(); if (conditionIntent) queueRefresh(); });
      conditionObserver.observe(root, { attributes: true, attributeFilter: ['class', 'style', 'hidden', 'disabled'], subtree: true });
    }
    groups.forEach((group, index) => {
      const first = nativeBoxes.find((box) => groupById.get(box.getAttribute('ymq-option-id')) === index);
      let button = root.querySelector(`.cz-rylan-option-step[data-cz-rylan-group="${index}"]`);
      if (!button) {
        button = window.czPdpShared.step(index, group.title, 'rylan').querySelector('button');
        steps.bind(button, index, (event) => event.detail === 0);
        button.addEventListener('click', (event) => { if (event.detail) button.blur(); });
      }
      // Rylan keeps YMQ's original sibling boxes instead of moving them into a synthetic panel.
      button.removeAttribute('aria-controls');
      if (!root.contains(button)) first.before(button);
    });
    const lengthButton = root.querySelector('.cz-rylan-option-step[data-cz-rylan-group="1"]');
    if (lengthButton && !lengthButton.closest('.cz-rylan-length-heading')) {
      const heading = document.createElement('div');
      heading.className = 'cz-rylan-length-heading';
      lengthButton.before(heading);
      heading.append(lengthButton);
    }
    nativeBoxes.forEach((box) => { box.dataset.czRylanGroup = String(groupById.get(box.getAttribute('ymq-option-id'))); });
    requireMountingChoice();
    let sizePanel = root.querySelector(':scope > .cz-rylan-size-panel');
    if (!sizePanel) {
      sizePanel = document.createElement('div');
      sizePanel.className = 'cz-rylan-size-panel';
      const figure = document.createElement('figure');
      figure.className = 'cz-rylan-size-figure';
      const zoom = document.createElement('button');
      zoom.type = 'button';
      zoom.className = 'cz-rylan-size-zoom';
      zoom.setAttribute('aria-label', 'Enlarge Rylan rod length measurement diagram');
      zoom.setAttribute('aria-haspopup', 'dialog');
      const source = document.getElementById('cz-rylan-length-image');
      let imageUrl = '';
      let image;
      try { imageUrl = JSON.parse(source?.textContent || '""'); } catch (_) { /* Keep native fields available if image data is missing. */ }
      if (imageUrl) {
        image = document.createElement('img');
        image.src = imageUrl;
        image.alt = 'Rylan rod length measurement diagram showing the full length including both end caps.';
        image.loading = 'lazy';
        image.decoding = 'async';
        const crop = document.createElement('span');
        crop.className = 'cz-rylan-size-crop cz-rylan-size-crop--length';
        const preview = image.cloneNode(true);
        preview.alt = '';
        crop.append(preview);
        zoom.append(crop);
        figure.append(zoom);
        const caption = document.createElement('figcaption');
        caption.textContent = 'Measure the full rod length, including both end caps · Tap to enlarge';
        figure.append(caption);
      }
      const fields = document.createElement('div');
      fields.className = 'cz-rylan-size-fields';
      sizePanel.append(figure, fields);
      root.querySelector(':scope > .cz-rylan-length-heading')?.after(sizePanel);
      boxes(1).forEach((box) => fields.append(box));
    }
    let confirm = root.querySelector('.cz-rylan-size-confirm');
    if (!confirm) {
      confirm = document.createElement('button');
      confirm.type = 'button';
      confirm.className = 'cz-rylan-size-confirm';
      confirm.textContent = 'Confirm Size';
      confirm.addEventListener('click', () => {
        const validLength = commitLength(true);
        const missing = missingBox(1);
        if (!validLength || missing) {
          if (missing) showError(missing);
          positionTitle(validLength ? fieldTitle(missing) : lengthEditor?.input);
          return;
        }
        clearErrors(1);
        steps.next(1);
      });
    }
    sizePanel.querySelector('.cz-rylan-size-fields')?.append(confirm);
    root.setAttribute('data-cz-rylan-steps', '');
    setupLengthInput();
    setupHelp();
    let imageUrl = '';
    try { imageUrl = JSON.parse(document.getElementById('cz-rylan-length-image')?.textContent || '""'); } catch (_) { /* Keep length fields available if image data is missing. */ }
    setupConnectorHelp(imageUrl);
    setupFieldHelp();
    setupWarrantyLink();
    setupPurchase();
    confirm.hidden = activeGroup !== 1;
    setActive(activeGroup);
    updateSummaries();
  }

  function scheduleSetup() {
    if (setupQueued) return;
    setupQueued = true;
    requestAnimationFrame(() => { setupQueued = false; setup(); });
  }

  function queueRefresh(nextIntent) {
    if (nextIntent) intent = nextIntent;
    if (refreshQueued) return;
    refreshQueued = true;
    requestAnimationFrame(refresh);
  }

  function refresh() {
    refreshQueued = false;
    updateSummaries();
    if (!root || !intent || !intent.input.isConnected || activeGroup !== intent.index) return;
    if (conditionIntent) {
      const { id, input, expires } = conditionIntent;
      const target = root.querySelector(`.ymq-options-box[ymq-option-id="${id}"]`);
      if (input.isConnected && performance.now() < expires && (!target || target.classList.contains('ymq-option-condition-hide') || target.style.display === 'none')) {
        setTimeout(queueRefresh, 60);
        return;
      }
      conditionIntent = undefined;
      const index = intent.index;
      intent = undefined;
      if (target && !target.classList.contains('ymq-option-condition-hide') && target.style.display !== 'none') {
        if (!missingBox(index) && index !== 1 && index < groups.length - 1) steps.next(index);
        else positionTitle(fieldTitle(target));
      }
      return;
    }
    const { index, fromTyping } = intent;
    intent = undefined;
    if (missingBox(index)) return;
    if (fromTyping && document.activeElement === lengthEditor?.input) return;
    clearErrors(index);
    if (index === 1) return;
    steps.next(index);
  }

  function rememberChoice(event) {
    if (!root || !event.isTrusted) return;
    const input = event.target.closest?.('.ymq-option-label')?.querySelector('input[type="radio"]') || event.target.closest?.('input[type="radio"]');
    if (!input || !root.contains(input)) return;
    const box = input.closest('.ymq-options-box');
    const index = Number(box?.dataset.czRylanGroup);
    if (index !== activeGroup) return;
    const targetId = conditionalTargets[box.getAttribute('ymq-option-id')]?.[input.value];
    conditionIntent = targetId ? { id: targetId, input, expires: performance.now() + 2500 } : undefined;
    queueRefresh({ input, index });
  }

  window.addEventListener('click', rememberChoice, true);
  window.addEventListener('change', (event) => {
    if (!root?.contains(event.target)) return;
    scheduleSummaries();
    const input = event.target;
    if (event.isTrusted && input.matches('input[type="radio"], select') && input.closest('.ymq-options-box')) {
      const box = input.closest('.ymq-options-box');
      const index = Number(box.dataset.czRylanGroup);
      if (index === activeGroup) {
        const targetId = conditionalTargets[box.getAttribute('ymq-option-id')]?.[input.value];
        conditionIntent = targetId ? { id: targetId, input, expires: performance.now() + 2500 } : undefined;
        queueRefresh({ input, index });
      }
    }
    setTimeout(updateSummaries, 80);
  }, true);
  window.addEventListener('input', (event) => {
    if (root?.contains(event.target) || event.target.matches?.('input[name="quantity"]') && root?.closest('.product-form')?.contains(event.target)) scheduleSummaries();
  }, true);
  window.addEventListener('click', (event) => {
    if (event.target.closest?.('button[name="add"], input[name="add"], .product-form__submit')) gateAdd(event);
  }, true);
  window.addEventListener('submit', (event) => {
    if (event.target.matches('form[action*="/cart/add"]')) gateAdd(event);
  }, true);
  window.addEventListener('invalid', (event) => {
    const box = event.target.closest?.('.ymq-options-box');
    if (box?.closest('ymq-option') !== root) return;
    const index = Number(box.dataset.czRylanGroup);
    setActive(index);
    positionTitle(fieldTitle(box));
  }, true);
  ['pointerdown', 'wheel', 'touchmove'].forEach((type) => window.addEventListener(type, () => { positionToken++; conditionIntent = undefined; intent = undefined; }, { capture: true, passive: true }));
  window.addEventListener('keydown', (event) => {
    if (['Tab', 'Enter', ' ', 'ArrowUp', 'ArrowDown', 'PageUp', 'PageDown', 'Home', 'End'].includes(event.key)) { positionToken++; conditionIntent = undefined; intent = undefined; }
  }, true);

  const observer = new MutationObserver((records) => {
    if (records.some((record) => [...record.addedNodes].some((node) => node.nodeType === 1 &&
      (node.matches?.('ymq-option, .ymq-options-box') || node.querySelector?.('ymq-option, .ymq-options-box'))))) scheduleSetup();
    if (root && records.some((record) => root.contains(record.target))) scheduleSummaries();
  });
  observer.observe(document.body, { childList: true, subtree: true });
  setup();
})();
